import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// import {
//    activeConverstaionSelector,
//    descktopUserListSelector,
//    openDesctopDialogueSelector,
// } from 'sites/state/modules/chat/selectors';
// import {
//    setOpenDesktopDialogueAction,
// } from 'sites/state/modules/chat/actions';
import {
   setLiveStreamConversationState,
   addNewMessage,
   updateMessage,
   setTyperAction,
   deleteMessageAction,
   likeMessageAction,
   setOnlineUsersAction,
   setStreamConversationInfo,
} from 'sites/state/modules/livestream/actions';
import {
   fetchLikedMemberByMessageOperation,
   fetchNewMessagesOperation,
} from 'sites/state/modules/livestream/operations';
import { authUserSelector, siteInfoSelector } from 'sites/state/modules/common/selectors';
// import Viewers from 'sites/views/live-stream/modules/viewers';

import {

   streamConversationSelector,
   messageDataSelector,
   isFetchingMessagesSelector,
   isConnectedSelector,
   onlineUsersSelector,
   likedMemberByMessageSelector,
   isFetchNewMessagesSelector,
   conversationSatetSelector,
} from 'sites/state/modules/livestream/selectors';
import Router from 'sites/routes/router';

import { push } from 'connected-react-router';
// import PageLoader from 'common/components/modules/page-loading';

// import ChatAvatarsBar from 'common/components/modules/chat/chat-right-side-avatars-bar';
// import MiniChatContainer  from 'sites/containers/modules/chat/other/mini-chat';
// import LiveChatNotifications  from 'sites/containers/modules/chat/other/notifications';
// import ChatCoversationForStream from 'sites/views/chat/coversiation-stream';
import Dialogue from "common/components/modules/chat/dialogue"
// import ChatProviderContainer from 'sites/containers/modules/chat';
// import { Consumer } from 'sites/containers/modules/chat/context';
import DateFormatter from 'common/utils/DateFormatter';
import toast, { positionToasterContainer } from 'common/utils/toast';
import ChatHepler from 'common/utils/chat';
import { isEmpty as isEmptyObject, keys } from 'lodash'
import { setReferrerUrl } from 'sites/utils/utils.js';

// import QueryParams from 'sites/utils/QueryParams';
class LiveStreamConversation extends Component {
   static propTypes = {
      isMobile: PropTypes.bool,
      setTyper: PropTypes.func,
      authUser: PropTypes.object,
      streamConversation: PropTypes.object,
      likeMessage: PropTypes.func,
      isConnected: PropTypes.bool,
      addNewMessage: PropTypes.func,
      updateMessage: PropTypes.func,
      deleteMessage: PropTypes.func,
      setOnlineUsers: PropTypes.func,
      // setLiveStreamConversationState: PropTypes.func,
      // showMiniPMConversation: PropTypes.bool,
      messageData: PropTypes.object,
      onlineUsers: PropTypes.array,
      // conversationSatet: PropTypes.object,
      // descktopUserList: PropTypes.array,
      // chatActiveConverstaion: PropTypes.object,
      fetchLikedMemberByMessage: PropTypes.func,
      likedMemberByMessage: PropTypes.object,
      // style: PropTypes.object,
      isNewFetching: PropTypes.bool,
      fetchNewMessages: PropTypes.func,
      setStreamConversationInfo: PropTypes.func,
      goTo: PropTypes.func,
      memberCanOnlyRead: PropTypes.bool,
      needToJoin: PropTypes.bool,
   };

   style = {};
   publicThreadTypersRemovers = {};

   filterMember = {
      page: 1,
   };
   filter = {
      page: 1,
   };
   previousY = 0;

   componentDidMount(){
      this.socket = window.adminLiveStreamSocket;
      this._initConnection();
      this._bindEvents();
   }

   _initConnection = () => {
      this.socket = window.siteLiveStreamSocket;
   }

   _bindEvents = () => {
      const { socket } = this;
      if(!socket) return
      const { authUser } = this.props
      socket.removeAllListeners('users:online');
      socket.removeAllListeners('user:online');
      socket.removeAllListeners('user:offline');
      socket.removeAllListeners('typing');
      socket.removeAllListeners('message:like');
      socket.removeAllListeners('message:delete');
      socket.removeAllListeners('message:send');

      socket.removeAllListeners('message:update');
      socket.removeAllListeners('conversation:read');
      socket.removeAllListeners('user:mute');
      socket.removeAllListeners('user:unmute');
      socket.removeAllListeners('conversation:seen');
      // socket.removeAllListeners('connect');
      // socket.removeAllListeners('connect_error');
      // socket.removeAllListeners('disconnect');
      // socket.removeAllListeners('ready');

      // socket.on('connect', (r) => {
      //    socket.emit('online')
      // });
      // socket.on('connect_error', (r) => {
      //    setIsConnectedAction(false)
      // });
      // socket.on('disconnect', (res) => {
      //    setIsConnectedAction(false)
      // });
      // socket.on('ready', () => {
      //    setIsConnectedAction(true)
      // });
      socket.on('users:online', (users) => {
         this.setOnlineMembers(users)
      });

      socket.on('user:online', (user) => {
         this.setOnlineMembers(user, 'push')
      });

      socket.on('user:offline', (user) => {
         this.setOnlineMembers(user, 'pop')
      });

      socket.on('typing', (data) => {
         const {
            user,
         } = data;
         const { isMobile } = this.props
         if(data.user.uuid !== authUser.uuid) {
            this.handleTyping(user)
         }
         const dialogue = document.querySelector(`#messages-content-live_stream`)
         if(dialogue){
            const { scrollHeight, clientHeight, scrollTop } = dialogue
            let diff =  (scrollHeight - clientHeight) - scrollTop
            if(diff < 110) {
               ChatHepler.syncDialogueScroll(null, 'live_stream')
            }
         }
         if(!isMobile) {
            ChatHepler.inputState()
         }

      });
      socket.on('message:send', async (data) => {
         const {
            message, user, tipAnimation,
         } = data
         const { isMobile } = this.props
         const messageData = { ...message, user, parent: message.parentMessage, sent_at: message.sentAt, unlock_details: message.unlockDetails }
         this.stopTyping(user.uuid)

         this.handleAddNewMessage({ message: messageData,  isMyMessage: data.user.uuid === authUser.uuid }, { tipAnimation, user })
         const dialogue = document.querySelector(`#messages-content-live_stream`)
         if(dialogue){
            const { scrollHeight, clientHeight, scrollTop } = dialogue
            let diff =  (scrollHeight - clientHeight) - scrollTop
            if(diff < 110) {
               ChatHepler.syncDialogueScroll(null, 'live_stream')
            }
         }
         if(!isMobile) {
            ChatHepler.inputState()
         }

      });

      socket.on('message:like', (data) => {
         this.handleLikeMessage({ ...data, isMyLiked: data.user.uuid === authUser.uuid })
      });

      socket.on('message:update', (data) => {
         const {
            message,
         } = data

         this.handleUpdateThisMessage(message.id, { ...message })
      });

      socket.on('message:delete', (data) => {
         const {
            messageId,
         } = data
         this.handleDeleteMessage(messageId)
      });

   }

   setOnlineMembers = (data, action) => {
      const { setOnlineUsers, onlineUsers } = this.props
      let index = null
      if(action) {
         index = onlineUsers.findIndex(elm => elm.uuid === data.uuid)
      }
      const returnFunction = (index > -1 && 'push' === action) || (index < 0 && 'pop' === action)
      if(returnFunction) {
         return
      }
      setOnlineUsers(data, action)
   }

   // start user typing *************
   onUserTyping = () => {
      this.socket.emit('typing', null)
   }

   handleTyping = (user) => {
      const { setTyper, streamConversation } =  this.props
      const userUuid = user.uuid
      let timeout = {}
      timeout = this.publicThreadTypersRemovers;
      if(streamConversation) {
         const typers = { ...streamConversation.typers }
         const userTyper = typers[userUuid]
         if(!userTyper) {
            typers[userUuid] = user;
         }
         setTyper(typers)
         const timeoutId = timeout[userUuid];
         if(timeoutId) {
            clearTimeout(timeoutId);
         }
         timeout[userUuid] = setTimeout(() => {
            this.stopTyping(userUuid)
         }, 5000);
      }
   }
   stopTyping = (userUuid) => {
      let typers = {}
      const { streamConversation, setTyper } =  this.props
      typers = { ...streamConversation.typers }
      delete typers[userUuid]
      setTyper(typers)
      delete this.publicThreadTypersRemovers[userUuid];
   }

   getTypesText = () => {
      const { typers } = this.props.streamConversation
      let message = null;
      if(typers && !isEmptyObject(typers)) {
         const objectKeys = keys(typers);
         if(objectKeys.length > 1) {
            message = 'Several people are typing...';
         } else {
            message = `${ typers[objectKeys[0]].username || typers[objectKeys[0]].screen_name }  is typing...`;
         }
      }
      return message
   }

   // end user typing ***********

   // start send and update message ********

   onSendMessage =  (text, parent, updateMessageId, callback) => {
      if(updateMessageId) {
         this.updateThisMessage(updateMessageId, text, callback)
      } else {
         this.sendNewMessage(text, parent, callback)
      }
   }


   handleAddNewMessage = (data, info) => {
      const { addNewMessage } = this.props
      addNewMessage(data, info)
   }

   sendNewMessage = async (newMessage, parent, callback) => {
      let randomid = Math.random() * (700 - 2000) + 2000;
      const { authUser } = this.props
      const parentMessageId = parent ? parent.parentMessageId : null
      var sentAt = DateFormatter.getCurentTimeMilliseconds()
      let newData = {
         parentMessageId,
         sentAt,
      }

      let newMessageData = {
         sent_at: sentAt,
         id: randomid,
         is_liked_by_user: false,
         likes_count_from_other_users: 0,
         parent: parentMessageId ? parent : null,
         user: authUser,
         type: 'text_message',
      }
      if(typeof newMessage === 'string') {
         newMessageData = {
            ...newMessageData,
            text: newMessage,
         }
         newData = {
            ...newData,
            text: newMessage,
         }
      }

      await this.handleAddNewMessage({ message: newMessageData, isMyMessage: true })

      this.socket.emit('message:send', newData, data => {
         const { updateMessage } = this.props
         let message = {}
         if(data.error) {
            switch (data.error) {
               case 'message_is_too_long':
                  // toast.error('Message must be 20000 characters or less')
                  break;
               case 'conversation_is_not_active':

                  break;
               case 'incorrect_payload':
                  break;

               case 'internal_server_error':
                  break;

               case 'access_denied':
                  break;

               default:
                  break;
            }
         } else {
            const { messageId, parentMessage } = data.data
            message = {
               id: messageId,
               parent: parentMessage,
            }
            updateMessage({ messageId: randomid,  message  })
         }
      })
      if(callback) {
         callback()
      }
   }

   updateThisMessage = async (messageId, text, callback) => {
      const newData = { messageId, text }
      this.socket.emit('message:update', newData, (data) => {
         if(data.error) {
            toast.error('Message must be 20000 characters or less')
         }
      })
      if(text.length < 20001) {
         await this.handleUpdateThisMessage(messageId, { text, edited: true })
      }
      if(callback && text.length < 20001) {
         callback()
      }
   }

   handleUpdateThisMessage = (messageId, message) => {
      const { updateMessage } = this.props
      updateMessage({ messageId,  message })
   }

   // end send and update message *******

   // start delete message
   onDeleteMessag = (id) => {
      const { isMobile } = this.props
      this.socket.emit('message:delete', { messageId: id })
      this.handleDeleteMessage(id)
      toast.remove('Message has been unsent', isMobile ? { onOpen: () => {
         positionToasterContainer('60px')
      } } : {})
   }

   handleDeleteMessage = id => {
      const { deleteMessage } = this.props
      deleteMessage(id)
   }

   // end delete message


   // start message like
   onLikeMessage = (messageId, isLiked) => {
      const data = {
         messageId, isLiked,
      }
      this.socket.emit('message:like', data);
      this.handleLikeMessage({ ...data, isMyLiked: true });
   }

   handleLikeMessage = (data) => {
      const { likeMessage } = this.props;
      likeMessage(data);
   }

   // end message like


   // liked members pagination
   handleScrollMembers = (e, id) => {
      const { scrollHeight, clientHeight, scrollTop } = e.target
      if(((scrollHeight - scrollTop) - clientHeight < 10)) {
         this.nextPageMembers(id)
      }
   }
   nextPageMembers =  (id) => {
      const {
         fetchLikedMemberByMessage,
         likedMemberByMessage,
         likedMemberByMessage: { current_page: currentPage, last_page: pages },
      } = this.props;
      let query = [];
      if(currentPage < pages && !likedMemberByMessage.fetchingScroll) {
         this.filterMember = { ...this.filterMember, page: currentPage + 1 };
         query = this.generateQuery(this.filterMember);
         fetchLikedMemberByMessage(query, id);
      } else {
         return
      }
   }

   //messages pagination
   handleScroll = e => {
      const { scrollTop, scrollHeight, firstElementChild } = e.target
      var currentY = scrollTop;
      if(currentY - 10 < scrollHeight - this.previousY && currentY === 0) {
         this.nextPage(async () => {
            const top = firstElementChild.clientHeight - this.previousY
            e.target.scrollTo(0, top);
         })
      }
      this.previousY = firstElementChild.clientHeight;
   }
   nextPage = async (callback) => {
      const {
         fetchNewMessages,
         isNewFetching,
         messageData: { current_page: currentPage, last_page: pages },
      } = this.props;
      let query = [];
      if(currentPage < pages && !isNewFetching) {
         this.filter = { ...this.filter, page: currentPage + 1 };
         query = this.generateQuery(this.filter);
         await fetchNewMessages(query);
         if(callback) {
            callback()
            return
         }
         return
      } else {
         return
      }
   }

   generateQuery = (filter) => {
      const query = [];
      Object.keys(filter).forEach((key) => {
         if(key === 'count' || key === 'page') {
            query.push(`${ key }=${ filter[key] }`);
         } else {
            query.push(`query[]=${ key }=${ filter[key] }`)
         }
      })
      return query;
   }

   render() {
      const {
         authUser,
         streamConversation,
         messageData,
         // conversationSatet,
         // setLiveStreamConversationState,
         // descktopUserList,
         // chatActiveConverstaion,
         isConnected,
         fetchLikedMemberByMessage,
         likedMemberByMessage,
         isNewFetching,
         // showMiniPMConversation,
         // setOpenDesktopDialogue,
         isMobile,
         setStreamConversationInfo,
         memberCanOnlyRead,
         needToJoin,
         goTo,
         // style,

      } = this.props;
      return (
         // <div
         //    style={ {
         //       ...style,
         //       height: '94%',
         //       width: '500px',
         //    } }
         //    className={ isMobile ? 'bg-panel dark:bg-panel-dark border border-divider flex relative w-full' : 'fixed right-0 z-10 flex flex-1 bottom-0' }>
         <>
            <Dialogue
               onDeleteMessag={  this.onDeleteMessag  }
               onUserTyping={ this.onUserTyping  }
               sendMessage={ this.onSendMessage }
               typerText={ this.getTypesText() }
               onLikeMessage={  this.onLikeMessage  }
               isConnected={ isConnected }
               onReadMessage={ () => {
                  if(streamConversation.unread_messages_count) {
                     setStreamConversationInfo({ unread_messages_count: 0 })
                  }
               } }
               onFetchLikesInfo={ (query, id) => fetchLikedMemberByMessage(query, id) }
               likesInfo={ likedMemberByMessage  }
               onScroll={  this.handleScroll  }
               onLikedMemberPagination={ this.handleScrollMembers }
               isNewFetching={ isNewFetching }
               isAdmin={ false }
               adminChatSettings={ { chatOff: true, active: true } }
               memberCanOnlyRead={ memberCanOnlyRead }
               needToJoin={ needToJoin }
               isMobile={ isMobile }
               ///////
               messages={ messageData?.data || [] }
               converstionInfo={ streamConversation }
               isEmpty={ false }
               unmuteMember={ () => {} }
               emptyState={ {
                  button_text: 'More info on chat',
                  action: () => {},
                  text: 'emptyText',
                  avatar: '',
               } }
               onClickUserAvatar={ () => {} }
               goToChatSettings={ () => {
               } }
               goToContentMessage={ id => {
               } }
               goToJoin={ () => {
                  const pageInfo = {
                     route_name: 'LIVE_STREAM_STUDIO',
                     page_name: 'livestream',
                     route_id: null,
                     goBack: 'livestream',
                  }

                  setReferrerUrl(pageInfo)
                  goTo(Router.route('JOIN').getCompiledPath(), `?liveStreamId=chat`)
               } }
               authUser={ authUser }
               isLivstream
               diff={ 72 }
               goTo={ goTo }
            />
         </>
      )
   }
}

const mapStateToProps = state => ({

   authUser: authUserSelector(state),
   siteInfo: siteInfoSelector(state),
   // converstions: converstionsSelector(state),
   streamConversation: streamConversationSelector(state),
   // chatActiveConverstaion: activeConverstaionSelector(state),
   messageData: messageDataSelector(state),
   isFetchingMessages: isFetchingMessagesSelector(state),
   conversationSatet: conversationSatetSelector(state),
   // activeConverstaion: activeConverstaionSelector(state),
   // descktopUserList: descktopUserListSelector(state),
   isConnected: isConnectedSelector(state),
   onlineUsers: onlineUsersSelector(state),
   likedMemberByMessage: likedMemberByMessageSelector(state),
   isNewFetching: isFetchNewMessagesSelector(state),
   // showMiniPMConversation: openDesctopDialogueSelector(state),
})
const mapDispatchToProps = dispatch => ({

   setLiveStreamConversationState: data => dispatch(setLiveStreamConversationState(data)),
   addNewMessage: (data, info) => dispatch(addNewMessage(data, info)),
   updateMessage: data => dispatch(updateMessage(data)),
   setTyper: data => dispatch(setTyperAction(data)),
   deleteMessage: id => dispatch(deleteMessageAction(id)),
   likeMessage: data => dispatch(likeMessageAction(data)),
   setOnlineUsers: (data, action) => dispatch(setOnlineUsersAction(data, action)),
   fetchLikedMemberByMessage: (q, data) => dispatch(fetchLikedMemberByMessageOperation(q, data)),
   fetchNewMessages: query => dispatch(fetchNewMessagesOperation(query)),
   setStreamConversationInfo: data => dispatch(setStreamConversationInfo(data)),
   goTo: (path, search) => {
      dispatch(push({
         pathname: path,
         search,
      }))
   },
   // setOpenDesktopDialogue: bool => dispatch(setOpenDesktopDialogueAction(bool)),

})

export default connect(mapStateToProps, mapDispatchToProps)(LiveStreamConversation);
